interface IProps {
    onClick?: () => void;
    color?: string;
}

export const ArrowLeftBlack = (props: IProps) => {
    const { onClick, color = "black" } = props;

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5304 6.46967C14.8232 6.76257 14.8232 7.23744 14.5304 7.53033L10.0607 12L14.5304 16.4697C14.8232 16.7626 14.8232 17.2375 14.5304 17.5304C14.2375 17.8232 13.7626 17.8232 13.4697 17.5304L8.46966 12.5304C8.17681 12.2375 8.17681 11.7626 8.46966 11.4697L13.4697 6.46967C13.7626 6.17678 14.2375 6.17678 14.5304 6.46967Z" fill="black" />
            <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="11.25" stroke="black" stroke-width="1.5" />
        </svg>
    );
};
